import http from '../utils/http';
import config from '../config';
import actionTypes from '../actions/actionTypes';
import { TrainedModelSummary } from '@nexxt/common/types';

const { api } = config;
/** Request list of trained model summaries for this tenant, and dispatch to add to state. */
export function getTrainedModelSummaries() {
    const endpoint = `${api.endpoints.getTrainedModelSummaries}`;
    return async (dispatch) => {
        try {
            const resp = await http.get(endpoint);
            dispatch({
                type: actionTypes.GET_TRAINED_MODEL_SUMMARIES,
                payload: resp.data.summaries as TrainedModelSummary[]
            });
        } catch (err) {}
    };
}
